export const sidebarTaxonomies: {
  label: string
  propName: string
  queryParamName?: string
}[] = [
  {
    label: 'Developing organisation(s)',
    propName: 'organisations',
    queryParamName: 'organisationIds'
  },
  {
    label: 'Tool type(s)',
    propName: 'toolTypes',
    queryParamName: 'toolTypeIds'
  },
  {
    label: 'Metric type(s)',
    propName: 'metricTypes',
    queryParamName: 'metricTypeIds'
  },

  {
    label: 'Objective(s)',
    propName: 'objectives',
    queryParamName: 'objectiveIds'
  },
  {
    label: 'Impacted stakeholders',
    propName: 'impactedStakeholders',
    queryParamName: 'impactedStakeholderIds'
  },
  {
    label: 'Purpose(s)',
    propName: 'purposes',
    queryParamName: 'purposeIds'
  },
  {
    label: 'Target sector(s)',
    propName: 'targetSectors',
    queryParamName: 'targetSectorIds'
  },
  {
    label: 'Country of origin',
    propName: 'countries',
    queryParamName: 'countryIds'
  },
  {
    label: 'Lifecycle stage(s)',
    propName: 'lifecycles',
    queryParamName: 'lifecycleIds'
  },
  {
    label: 'Type of approach',
    propName: 'approaches',
    queryParamName: 'toolTYpeIds'
  },
  {
    label: 'Maturity',
    propName: 'maturities',
    queryParamName: 'maturityIds'
  },
  {
    label: 'Usage rights',
    propName: 'usageRights',
    queryParamName: 'usageRightIds'
  },
  {
    label: 'License',
    propName: 'licenses',
    queryParamName: 'licenseIds'
  },
  {
    label: 'Target groups',
    propName: 'targetGroups',
    queryParamName: 'targetGroupIds'
  },
  {
    label: 'Target users',
    propName: 'targetUsers',
    queryParamName: 'targetUserIds'
  },
  {
    label: 'Stakeholder group',
    propName: 'stakeholderGroups',
    queryParamName: 'stakeholderGroupIds'
  },
  {
    label: 'Validity',
    propName: 'validities',
    queryParamName: 'validityIds'
  },
  {
    label: 'Enforcement',
    propName: 'enforcements',
    queryParamName: 'enforcementIds'
  },
  {
    label: 'Benefits',
    propName: 'benefits',
    queryParamName: 'benefitIds'
  },
  {
    label: 'Geographical scope',
    propName: 'geographicalScopes',
    queryParamName: 'geographicalScopeIds'
  },
  {
    label: 'People involved',
    propName: 'peopleInvolveds',
    queryParamName: 'peopleInvolvedIds'
  },
  {
    label: 'Required skills',
    propName: 'requiredSkills',
    queryParamName: 'requiredSkillIds'
  },
  {
    label: 'Risk management stage(s)',
    propName: 'risks',
    queryParamName: 'riskIds'
  },
  {
    label: 'Technology platforms',
    propName: 'technologyPlatforms',
    queryParamName: 'technologyPlatformIds'
  },
  {
    label: 'Programming languages',
    propName: 'programmingLanguages',
    queryParamName: 'programmingLanguageIds'
  }
]
